import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { API } from 'aws-amplify';
import { Observable, from } from 'rxjs';
import { Amount } from './orders.service';
import { DEFAULT_GET_LIMIT } from '../shared/constants/operationals';

export const STEPS_API_NAME: string = 'steps';
export const STEPS_API_ENDPOINT: string = environment.API_BASE_PATH + '/step';

@Injectable({
  providedIn: 'root',
})
export class StepsService {
  listSteps(list_params?: ListStepsParams): Observable<any> {
    const api_name: string = STEPS_API_NAME;
    const path: string = '';

    let query_string_params: any = {
      cursor: list_params?.cursor || null,
      limit: list_params?.limit || DEFAULT_GET_LIMIT,
    };
    if (list_params?.order_id) query_string_params['order_id'] = list_params.order_id;
    if (list_params?.qinetic_id) query_string_params['qinetic_id'] = list_params.qinetic_id;
    if (list_params?.steps_id) query_string_params['steps_id'] = list_params.steps_id;
    if (list_params?.created_from) query_string_params['created_from'] = list_params.created_from;
    if (list_params?.created_to) query_string_params['created_to'] = list_params.created_to;
    if (list_params?.due_date_from) query_string_params['due_date_from'] = list_params.due_date_from;
    if (list_params?.due_date_to) query_string_params['due_date_to'] = list_params.due_date_to;

    const init = { response: true, queryStringParameters: query_string_params };
    return from(API.get(api_name, path, init));
  }

  listByOrder(store_id: string, order_id: string): Observable<any> {
    const api_name: string = STEPS_API_NAME;
    const path: string = `/order/${order_id}/store/${store_id}`;
    const init = { response: true };
    return from(API.get(api_name, path, init));
  }

  readSummary(): Observable<any> {
    const api_name: string = STEPS_API_NAME;
    const path: string = '/summary';
    const init = { response: true };
    return from(API.get(api_name, path, init));
  }
}

export interface ListStepsParams {
  order_id?: string;
  qinetic_id?: string;
  steps_id?: string;
  created_from?: number;
  created_to?: number;
  due_date_from?: number;
  due_date_to?: number;

  cursor?: string | null;
  limit?: number;
}

export interface Step {
  step_id?: string;
  order_id?: string;
  store_id?: string;
  buyer_id?: string;
  status?: StepStatus;
  amount?: Amount;
  charge_attempts_counter?: number;
  index?: number;

  qinetic_position_id?: string;
  position_id?: string;
  position_error?: any;

  stripe_pi?: string;
  stripe_pi_client_secret?: string;

  due_date?: number;
  pending_at?: number;
  completed_at?: number;
  canceled_at?: number;
  refunded_at?: number;
  created_at?: number;
  updated_at?: number;

  is_manually_paid?: boolean;
  manual_payment_requested_at?: number;
  manual_payment_collected_at?: number;
  completed_by_bank_transfer_at?: number;
}

export enum StepStatus {
  pending = 'pending',
  completed = 'completed',
  refunded = 'refunded',
  canceled = 'canceled',
}

export interface StepSummary {
  length: number;
  pending: number;
  completed: number;
  canceled: number;
  refunded: number;
}
